import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '../../configuration/setup/store';

export const selectApp = (state: RootState) => state.app;
export const selectSessionExpiredAcknowledged = createSelector(selectApp, state => state.sessionExpiredAcknowledged);
export const selectIsSearchWidget = createSelector(selectApp, state => state.isSearchWidget);
